import { render, staticRenderFns } from "./PublicSearchNew.vue?vue&type=template&id=03b0d37a&scoped=true&"
import script from "./PublicSearchNew.vue?vue&type=script&lang=js&"
export * from "./PublicSearchNew.vue?vue&type=script&lang=js&"
import style0 from "./PublicSearchNew.vue?vue&type=style&index=0&id=03b0d37a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b0d37a",
  null
  
)

export default component.exports